// extracted by mini-css-extract-plugin
export var body = "_ny-8";
export var button = "_ny-0";
export var closeButton = "_ny-5";
export var content = "_ny-3";
export var empty = "_ny-f";
export var grid = "_ny-c";
export var header = "_ny-4";
export var icon = "_ny-1";
export var option = "_ny-d";
export var optionSelected = "_ny-e";
export var overlay = "_ny-2";
export var searchIcon = "_ny-a";
export var searchInput = "_ny-b";
export var searchWrapper = "_ny-9";
export var title = "_ny-6";
export var visuallyHidden = "_ny-7";